import ua from '@/locales/ua.json'
import en from '@/locales/en.json'
import ru from '@/locales/ru.json'

const locales = {
    'ua-UA': ua,
    'en-US': en,
    'ru-RU': ru
}

export default function localizeFilter(key) {
    var keys = key.split('.');
    const locale = localStorage.getItem("locale");
    var local = locales[locale] ?? locales['ua-UA'];
    keys.forEach(item => {
        try {
            local = local[item];
        }
        catch {
            local = `[Localize error] ${key} not found`;
        }
    });

    return local;
}
